<template>
  <div class="container">
    <img src="../../assets/padApp/pad_banner.png" class="banner" />
    <div class="btns">
      <van-button class="android_download_btn" @click="judgeWechat">
        <template #default>
          <div class="android_download_btn_inner">
            <img
              src="../../assets/padApp/android_btn.png"
              alt="Android下载按钮"
              class="android_btn_img"
            />
            <div class="android_btn_inner_right">
              <div class="android_download_btn_inner_text">
                Android 立即下载
              </div>
              <div class="android_download_btn_inner_desc">
                约{{ fileSize }}MB
              </div>
            </div>
          </div>
        </template>
      </van-button>
      <van-button class="ios_download_btn">
        <template #default>
          <div class="android_download_btn_inner">
            <img
              src="../../assets/padApp/ios_btn.png"
              alt="iOS下载按钮"
              class="android_btn_img"
            />
            <div class="ios_btn_inner_right">
              <div class="ios_download_btn_inner_text">iOS App Store</div>
              <div class="android_download_btn_inner_desc">即将上线</div>
            </div>
          </div>
        </template>
      </van-button>
    </div>
  </div>
</template>

<script>
import { isWechat } from "@/util/wechat.js";
import { getPadAppUrl } from "@/util/tools.js";

export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      fileSize: "",
      type: false,
      introduceList: [
        {
          title: "智慧开单",
          desc: [
            "零售·批发·回收",
            "10秒完成开单",
            "AI自动识别商品",
            "支持一口价/料+工费",
          ],
          icon: require("../../assets/padApp/pad_icon_1.png"),
        },
        {
          title: "金价实时同步",
          desc: [
            "自行选择价格数据源",
            "Au9999·Ag999·Pt950",
            "实时价格",
            "自行加价",
          ],
          icon: require("../../assets/padApp/pad_icon_2.png"),
        },
        {
          title: "多门店管理",
          desc: ["统一商品信息", "支持一物一码", "门店独立经营", "数据互通"],
          icon: require("../../assets/padApp/pad_icon_3.png"),
        },
        {
          title: "多门店管理",
          desc: ["扫码盘点", "智能预警", "滞销/畅销", "在库信息一目了然"],
          icon: require("../../assets/padApp/pad_icon_4.png"),
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {
    getPadAppUrl().then((res) => {
      this.fileSize = res.data.data.fileSize;
    });
  },
  mounted() {},
  methods: {
    // 下载
    downLoadApp() {
      getPadAppUrl().then((res) => {
        window.open(res.data.data.url);
      });
    },
    // 判断是否为微信浏览器
    judgeWechat() {
      this.type = isWechat();
      if (!this.type) {
        this.downLoadApp();
      }
    },
  },
};
</script>

<style scoped>
.container {
  height: 100vh;
  background: #fcf7f3;
  position: relative;
  overflow: hidden;
  /* box-sizing: border-box; */
  /* padding-bottom: calc(80px + constant(safe-area-inset-bottom));
  padding-bottom: calc(80px + env(safe-area-inset-bottom)); */
}
.btns {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
}
.android_btn_inner_right {
  display: flex;
  align-items: baseline;
  gap: 20px;
  > div:nth-child(2) {
    /* padding-top: 4px; */
  }
}
.ios_btn_inner_right {
  display: flex;
  align-items: baseline;
  gap: 20px;
  > div:nth-child(2) {
    /* padding-top: 4px; */
    padding-left: 48px;
  }
}
.android_download_btn {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 670px;
  height: 90px;
  background: linear-gradient(180deg, #fd9a3b 0%, #fe6e01 100%);
  box-shadow: 0px 4px 8px 1px rgba(252, 92, 14, 0.56);
  border-radius: 45px 45px 45px 45px;
  border: none;
  color: #ffffff;
  font-size: 32px;
  margin: 0 auto;

  padding: 0 82px;
}
.ios_download_btn {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 670px;
  height: 90px;
  background: #ffffff;
  box-shadow: 0px 4px 8px 1px rgba(197, 197, 197, 0.56);
  border-radius: 45px 45px 45px 45px;
  border: none;
  color: #333333;
  font-size: 32px;
  margin: 0 auto;
  margin-top: 30px;
  padding: 0 82px;
}
.android_download_btn_inner {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
}
.android_download_btn {
}
.android_download_btn_inner_text {
  font-size: 32px;
  font-weight: bold;
}
.ios_download_btn_inner_text {
  font-size: 32px;
  font-weight: bold;
}
.android_download_btn_inner_desc {
  font-size: 24px;
  font-weight: bold;
  /* color: #ffffff; */
}
.android_btn_img {
  width: 72px;
  height: 72px;
}
p {
  margin: 0;
}
.line {
  width: 31px;
  height: 3px;
  background: #ff7201;
  border-radius: 6px 6px 6px 6px;
}
.banner {
  width: 100%;
  height: auto;
  /* object-fit: cover;
  object-position: top center; */
  display: block;
}

.desc_container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 24px;
}

.desc {
  color: #999999;
  font-size: 22px;
  font-weight: 500;
}

.introduce_container {
  width: 673px;
  height: 580px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 18px;
  /* gap: 8px; */
  margin: 0 auto;
  margin-top: -108px;
}
.introduce {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  /* justify-content: space-between; */
  box-shadow: 4px 8px 6px 1px rgba(0, 0, 0, 0.08);
  border-radius: 20px 20px 20px 20px;
  background: #ffffff;
  width: 324px;
  height: 290px;
}

.introuce_top {
  display: flex;
  align-items: center;
  gap: 0px;
  > img {
    width: 108px;
    height: 108px;
  }
}

.introduce_top_right {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.introduce_title {
  font-weight: 500;
  font-size: 30px;
  color: #333333;
  margin: 0;
}
</style>
